import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { company, navLinks, services } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-brand-blue-dark text-slate-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-5">
              <div className="flex items-center justify-center w-11 h-11 rounded-full bg-gradient-to-br from-brand-blue to-brand-orange">
                <Activity className="w-6 h-6 text-white" strokeWidth={2.5} />
              </div>
              <div className="leading-tight">
                <div className="font-heading font-extrabold text-lg text-white">Trusted Companion</div>
                <div className="font-heading font-semibold text-[11px] text-brand-orange -mt-0.5 tracking-[0.15em] uppercase">Health Care</div>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              Warm, person-centred home care and dependable healthcare staffing, delivered with compassion and professionalism across Ireland.
            </p>
            <div className="flex gap-3 mt-6">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#social" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-orange flex items-center justify-center transition-colors duration-200">
                  <Icon className="w-4 h-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-lg mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-slate-300 hover:text-brand-orange transition-colors duration-200">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-lg mb-5">Our Services</h4>
            <ul className="space-y-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to="/services" className="text-sm text-slate-300 hover:text-brand-orange transition-colors duration-200">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-lg mb-5">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-brand-orange shrink-0 mt-0.5" />
                <span className="text-sm text-slate-300">{company.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-brand-orange shrink-0" />
                <span className="text-sm text-slate-300">{company.primaryPhone}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-brand-orange shrink-0" />
                <span className="text-sm text-slate-300">{company.email}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} {company.legalName} trading as {company.name}. All rights reserved.</p>
          <p className="text-xs text-slate-400">Privacy Policy · Terms &amp; Conditions</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
